var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeader"},[_c('div',{staticClass:"pageTitle"},[_vm._t("left",function(){return [_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.tip)?_c('span',{staticClass:"pageTitle-tip"},[_vm._v(_vm._s(_vm.tip))]):_vm._e()]})],2),_c('div',{staticClass:"pageTitle-right"},[_vm._t("right",function(){return [_vm._t("default")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }